import styled from '@emotion/styled'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { AppContext } from 'main/framework'
import { schoolSearchLocationPath } from 'main/routes'
import { breakpoints, TextField } from 'main/ui'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'
import { ISearchProps } from './types'

const Form = styled.form`
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    width: 280px;
  }
`

const PRE = `${i18nKeyPrefix}-HEADER-SEARCH`

interface IProps extends RouteComponentProps {
  currentSearch?: ISearchProps
}

function SearchForm(props: IProps) {
  const { history, currentSearch } = props
  const { ipLocation } = React.useContext(AppContext)
  const currentQuery = resolveCurrentQuery()
  const [query, setQuery] = React.useState<string>(currentQuery)

  React.useEffect(() => {
    setQuery(currentQuery)
  }, [currentQuery, ipLocation])

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Form onSubmit={event => handleSubmit(event)}>
      <TextField
        label={t(`${PRE}-LABEL`)}
        placeholder={t(`${PRE}-PLACEHOLDER`)}
        value={query}
        onChange={setQuery}
      />
    </Form>
  )

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()

    const filters = currentSearch && currentSearch.filters
    const path = schoolSearchLocationPath(query, filters)
    history.push(path)
    location.reload()
  }

  function resolveCurrentQuery(): string {
    const hasQuery = currentSearch && currentSearch.query !== ''

    if (hasQuery) {
      return currentSearch?.query
    }

    if (ipLocation?.cityName && ipLocation?.regionName) {
      return `${ipLocation.cityName}, ${ipLocation.regionName}`
    }

    return ''
  }
}

export default withRouter(SearchForm)
